import { useEffect, useState } from 'react';

const navItems = [
  { label: '热播榜', href: '#ranking' },
  { label: '作品库', href: '#library' },
  { label: '新番导视', href: '#season' },
  { label: '编辑精选', href: '#picks' },
  { label: '完结神作', href: '#classics' },
  { label: '追番指南', href: '#guide' },
  { label: '漫迷问答', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 cursor-pointer">
          <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-play-circle-fill text-xl"></i>
          </span>
          <span
            className={`font-heading text-lg font-bold tracking-wide ${
              scrolled ? 'text-foreground-950' : 'text-background-50'
            }`}
          >
            91动漫
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`px-3 py-2 text-sm rounded-md cursor-pointer transition-colors ${
                scrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-background-100 hover:text-background-50 hover:bg-white/10'
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="#library"
            className="inline-flex items-center gap-1.5 px-4 py-2 text-sm rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-search-line"></i>
            找作品
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          onClick={() => setOpen((v) => !v)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
            scrolled ? 'text-foreground-900' : 'text-background-50'
          }`}
        >
          <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200">
          <nav className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 text-sm text-foreground-800 rounded-md hover:bg-primary-50 hover:text-primary-600 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#library"
              onClick={() => setOpen(false)}
              className="mt-2 px-3 py-2.5 text-sm text-center rounded-md bg-primary-500 text-background-50 cursor-pointer"
            >
              找作品
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}